import * as actions from './actionsTypes';

const initialState = {
  isLoadingEmployeeCalendarEvents: false,
  isLoadingEmployeeCalendarEvent: false,
  isSaveEmployeeCalendarEvent: false,
  calendarEmployeeEvents: null,
  employeeCalendarEvent: null,
  employeeCalendarEventsFail: null,
  employeeCalendarEventFail: null,
  employeeCalendarSaveEventFail: null
};

// Reducer de User_Calendar_Events
const calendarEmployeeEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENTS:
      return {
        ...state,
        isLoadingEmployeeCalendarEvents: action.payload
      };
    case actions.IS_LOADING_EMPLOYEE_CALENDAR_EVENT:
      return {
        ...state,
        isLoadingEmployeeCalendarEvent: action.payload
      };
    case actions.IS_SAVE_EMPLOYEE_CALENDAR_EVENT:
      return {
        ...state,
        isSaveEmployeeCalendarEvent: action.payload
      };
    case actions.GET_EMPLOYEE_CALENDAR_EVENTS:
      return {
        ...state,
        calendarEmployeeEvents: action.payload
      };
    case actions.GET_EMPLOYEE_CALENDAR_EVENT:
      return {
        ...state,
        employeeCalendarEvent: action.payload
      };
    case actions.FAIL_EMPLOYEE_CALENDAR_EVENTS:
      return {
        ...state,
        employeeCalendarEventsFail: action.payload
      };
    case actions.FAIL_EMPLOYEE_CALENDAR_EVENT:
      return {
        ...state,
        employeeCalendarEventFail: action.payload
      };
    case actions.FAIL_SAVE_EMPLOYEE_CALENDAR_EVENT:
      return {
        ...state,
        employeeCalendarSaveEventFail: action.payload
      };
    default:
      return state;
  }
};

export default calendarEmployeeEventsReducer;